import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { PlatformStatusProvider } from "./context/PlatformStatusContext";
import PlatformUnavailableOverlay from "./components/PlatformUnavailableOverlay";
import PlatformCheckWrapper from "./components/PlatformCheckWrapper";
import { PhoneFrameWrapper } from "./pages/MobilePreviewPage";
import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import SignupPage from "./pages/SignupPage";
import AuthChoicePage from "./pages/AuthChoicePage";
import HomePage from "./pages/HomePage";
import RestaurantPage from "./pages/RestaurantPage";
import CartPage from "./pages/CartPage";
import CheckoutPage from "./pages/CheckoutPage";
import OrderSuccessPage from "./pages/OrderSuccessPage";
import OrdersPage from "./pages/OrdersPage";
import ProfilePage from "./pages/ProfilePage";
import FavouriteDishesPage from "./pages/FavouriteDishesPage";
import FavouriteRestaurantsPage from "./pages/FavouriteRestaurantsPage";
import AddressesPage from "./pages/AddressesPage";
import AboutFleetyPage from "./pages/AboutFleetyPage";
import PaymentMethodsPage from "./pages/PaymentMethodsPage";
import TermsConditionsPage from "./pages/TermsConditionsPage";
import FAQsPage from "./pages/FAQsPage";
import PaymentStatusPage from "./pages/PaymentStatusPage";
import DisputePage from "./pages/DisputePage";
// FleetyGo Pages
import FleetyGoHomePage from "./pages/FleetyGoHomePage";
import FleetyGoBookingPage from "./pages/FleetyGoBookingPage";
import FleetyGoPaymentPage from "./pages/FleetyGoPaymentPage";
import FleetyGoPaymentStatusPage from "./pages/FleetyGoPaymentStatusPage";
import FleetyGoTrackingPage from "./pages/FleetyGoTrackingPage";
import FleetyGoOrdersPage from "./pages/FleetyGoOrdersPage";
import FleetyGoFavoritesPage from "./pages/FleetyGoFavoritesPage";
import FleetyGoProfilePage from "./pages/FleetyGoProfilePage";
import AboutFleetyGoPage from "./pages/AboutFleetyGoPage";
import FleetyGoTermsPage from "./pages/FleetyGoTermsPage";
import FleetyGoFAQsPage from "./pages/FleetyGoFAQsPage";
import FleetyGoPrivacyPage from "./pages/FleetyGoPrivacyPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <PlatformStatusProvider>
          {/* Platform Unavailable Overlay - blocks everything when app is disabled */}
          <PlatformUnavailableOverlay />
          
          {/* Wrapper to check platform status on navigation */}
          <PlatformCheckWrapper>
            <PhoneFrameWrapper>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/landing" element={<LandingPage />} />
              <Route path="/auth" element={<AuthChoicePage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/signup" element={<SignupPage />} />
              <Route path="/home" element={<HomePage />} />
              <Route path="/restaurant/:id" element={<RestaurantPage />} />
              <Route path="/cart" element={<CartPage />} />
              <Route path="/checkout" element={<CheckoutPage />} />
              <Route path="/order-success/:orderId" element={<OrderSuccessPage />} />
              <Route path="/payment-status/:orderId" element={<PaymentStatusPage />} />
              <Route path="/payment-status" element={<PaymentStatusPage />} />
              <Route path="/orders" element={<OrdersPage />} />
              <Route path="/dispute/:orderId" element={<DisputePage />} />
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/favourite-dishes" element={<FavouriteDishesPage />} />
              <Route path="/favourite-restaurants" element={<FavouriteRestaurantsPage />} />
              <Route path="/addresses" element={<AddressesPage />} />
              <Route path="/about" element={<AboutFleetyPage />} />
              <Route path="/payment-methods" element={<PaymentMethodsPage />} />
          <Route path="/terms" element={<TermsConditionsPage />} />
          <Route path="/faqs" element={<FAQsPage />} />
          {/* FleetyGo Routes */}
          <Route path="/fleetygo" element={<FleetyGoHomePage />} />
          <Route path="/fleetygo/book" element={<FleetyGoBookingPage />} />
          <Route path="/fleetygo/payment" element={<FleetyGoPaymentPage />} />
          <Route path="/fleetygo/payment-status/:orderId" element={<FleetyGoPaymentStatusPage />} />
          <Route path="/fleetygo/track/:orderId" element={<FleetyGoTrackingPage />} />
          <Route path="/fleetygo/orders" element={<FleetyGoOrdersPage />} />
          <Route path="/fleetygo/favorites" element={<FleetyGoFavoritesPage />} />
          <Route path="/fleetygo/profile" element={<FleetyGoProfilePage />} />
          <Route path="/fleetygo/about" element={<AboutFleetyGoPage />} />
          <Route path="/fleetygo/terms" element={<FleetyGoTermsPage />} />
          <Route path="/fleetygo/faqs" element={<FleetyGoFAQsPage />} />
          <Route path="/fleetygo/privacy" element={<FleetyGoPrivacyPage />} />
            </Routes>
            </PhoneFrameWrapper>
          </PlatformCheckWrapper>
        </PlatformStatusProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
